import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bb71649"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  align: "center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "mt-2",
  align: "end"
}

import { useI18n } from "vue-i18n"
import { ref, onMounted, onBeforeUnmount } from "vue"
import { watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SeenUsers',
  props: {
    viewSeenList: { type: Boolean },
    usersList: {},
    studentHeader: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()
const openList = ref(props.viewSeenList)
const itemsPerPage = ref(-1)
const smallWindow = ref(window.innerWidth < 1000)

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onMounted(() => {
  window.addEventListener("resize", updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

watch(openList, () => {
  if (!openList.value) {
    emit("close")
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: openList.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((openList).value = $event)),
    "max-width": "450px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        border: "md",
        class: "pa-6 text-black mx-auto",
        color: "white",
        "min-width": "350px",
        style: {"border-radius":"7%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            style: {"margin-top":"9px"},
            "items-per-page": itemsPerPage.value,
            "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((itemsPerPage).value = $event)),
            headers: _ctx.studentHeader,
            items: _ctx.usersList
          }, {
            [`item.photo`]: _withCtx((props) => [
              (props.item.photo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_img, _mergeProps({
                      src: props.item.photo,
                      alt: "student Image"
                    }, props, {
                      class: "image mb-2",
                      referrerpolicy: "no-referrer",
                      rel: "noreferrer",
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.$router.push(`doctors/${props?.item?.doctorId}`))
                    }), null, 16, ["src", "onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_img, _mergeProps(props, {
                      src: require('../../../../assets/stud-team1.png'),
                      alt: "student Image",
                      class: "image mb-2",
                      referrerpolicy: "no-referrer",
                      rel: "noreferrer"
                    }), null, 16, ["src"])
                  ]))
            ]),
            bottom: _withCtx(() => []),
            _: 2
          }, 1032, ["items-per-page", "headers", "items"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              color: "error",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})